import Layout from '@layout/Index'

export const userBatchTag = [
  {
    path: '/user-batch-tag',
    component: Layout,
    children: [
      {
        path: 'add/form',
        component: () => import(/* webpackChunkName: "user-batch-tag-form" */ './pages/UserBatchAddTagForm.vue'),
        name: '批量添加用户标签',
        meta: {
          title: '批量添加用户标签',
        },
      },
      {
        path: 'delete/form',
        component: () => import(/* webpackChunkName: "user-batch-tag-form" */ './pages/UserBatchDelTagForm.vue'),
        name: '批量删除用户标签',
        meta: {
          title: '批量删除用户标签',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-batch-tag/user-batch-tag.route.js